// extracted by mini-css-extract-plugin
export default {"totalAmount":"PayNow_totalAmount__5-xZz","taxText":"PayNow_taxText__XMaJf"};